<script setup lang="ts">
import { isMobile } from "~/utils/constants";

const gridClass = computed(() => {
	const gridTemplateCols = isMobile
		? `30px 20px 45px 1fr 55px 55px`
		: `30px 25px 45px minmax(50px,1fr) repeat(3, minmax(20px, 70px)) minmax(20px, 150px) 55px 55px 55px 55px`;
	return `grid-template-columns: ${gridTemplateCols}`;
});
</script>
<template>
	<div class="rounded-lg overflow-hidden bg-light-50 dark:bg-dark-800">
		<div
			:style="gridClass"
			class="h-[40px] grid gap-1 rounded-sm shadow bg-dark-800 dark:bg-dark-700 dark:shadow-none p-1 items-center border-b border-b-light-400 dark:border-b-dark-500"
		>
			<div />
			<UiSkeleton class="h-[15px] bg-light-500 dark:bg-dark-500" />
			<div class="flex items-center justify-center">
				<UiSkeleton class="h-[15px] w-[35px] bg-light-500 dark:bg-dark-500" />
			</div>
			<UiSkeleton class="h-[15px] w-[70px] bg-light-500 dark:bg-dark-500" />
			<UiSkeleton class="h-[15px] w-[50px] bg-light-500 dark:bg-dark-500" />
			<UiSkeleton class="h-[15px] w-[50px] bg-light-500 dark:bg-dark-500" />
			<UiSkeleton class="h-[15px] w-[50px] bg-light-500 dark:bg-dark-500" v-if="!isMobile" />
			<div v-if="!isMobile" />
			<UiSkeleton class="h-[15px] bg-light-500 dark:bg-dark-500" v-if="!isMobile" v-for="k in 4" :key="`data-loader-${k}`" />
		</div>
		<div v-for="row in 10" :index="row" :class="row !== 10 ? `border-b border-b-light-400 dark:border-b-dark-500` : null">
			<div :style="gridClass" class="grid gap-1 px-1 leading-none rounded-sm shadow bg-light-50 dark:bg-dark-800 dark:shadow-none p-1 items-center">
				<UiSkeleton class="h-[30px] bg-light-500 dark:bg-dark-500" />
				<div class="flex items-center justify-center">
					<UiSkeleton class="h-[30px] w-[23px] bg-light-500 dark:bg-dark-500" />
				</div>

				<div class="flex items-center justify-center">
					<UiSkeleton class="h-[30px] w-[35px] bg-light-500 dark:bg-dark-500" />
				</div>

				<div>
					<UiSkeleton class="h-[18px] w-[80px] bg-light-500 dark:bg-dark-500 mb-[2px]" />
					<UiSkeleton class="h-[15px] w-[120px] bg-light-500 dark:bg-dark-500" />
				</div>

				<UiSkeleton :class="isMobile ? 'h-[30px]' : 'h-[15px]'" class="w-[50px] bg-light-500 dark:bg-dark-500" />
				<UiSkeleton :class="isMobile ? 'h-[30px]' : 'h-[15px]'" class="w-[50px] bg-light-500 dark:bg-dark-500" />
				<UiSkeleton class="h-[15px] w-[50px] bg-light-500 dark:bg-dark-500" v-if="!isMobile" />
				<div v-if="!isMobile" />
				<UiSkeleton class="h-[30px] bg-light-500 dark:bg-dark-500" v-if="!isMobile" v-for="k in 4" :key="`data-loader-${k}`" />
			</div>
		</div>
	</div>
</template>
